import dateTimeFormats from "../../constants/dateTimeFormats";

export const common = {
  ...dateTimeFormats.reduce((acc, format) => {
    acc[format] = `{{date, ${format}}}`;

    return acc;
  }, {} as Record<string, string>),
  accounts: "{{count}} account",
  accounts_plural: "{{count}} accounts",
  active: "Active",
  allCustomers: "All Customers",
  allowlist: "Allowlist",
  addedBy: "Added by",
  Applications: "Applications",
  "Bank accounts": "Bank accounts",
  banks: "Banks",
  blocklist: "Blocklist",
  cancel: "Cancel",
  cashManagement: "Cash Management",
  checkoutBranding: "Checkout Branding",
  circuitBreaker: "Circuit Breaker",
  "Client applications": "Client applications",
  configuration: "Configuration",
  connect: "Connect",
  copiedToClipboard: "Copied to clipboard",
  Copy: "Copy",
  country: "Country",
  currency: "Currency",
  CURRENCY: "{{data, CURRENCY}}",
  customers: "Customers",
  Dashboard: "Dashboard",
  date: "Date",
  Delete: "Delete",
  Details: "Details",
  disabled: "Disabled",
  "Don't have an account yet?": "Don't have an account yet?",
  download: "Download",
  "Email address": "Email address",
  enabled: "Enabled",
  enterApplicationName: "Enter application's name",
  Filter: "Filter",
  filters: "Filters",
  forbiddenError: "403 Error",
  inactive: "Inactive",
  incorrect2FASecurityCode: "Incorrect 2FA security code.",
  KEYBOARD_DATE: "dd/MM/yyyy",
  Login: "Login",
  "No results found": "No results found",
  "Not saved": "Not saved",
  noApplicationFound: "No application found",
  notFoundError: "404 Error",
  noResults: "No Results",
  noResultsFor:
    "There are no results for <strong>{{search}}</strong>, please check the spelling or try different keywords",
  OK: "OK",
  Password: "Password",
  payments: "Payments",
  productionMode: "production mode",
  readLess: "Read Less",
  readMore: "Read More",
  RELATIVE_DATE_TIME: "{{date, RELATIVE_DATE_TIME}}",
  "Remember my email": "Remember my email",
  resend2FA: "Resend 2FA",
  resend2FASuccess: "2FA code has been resent",
  reset: "Reset",
  resetSearch: "Reset Search",
  Retry: "Retry",
  returnToDashboard: "Return to dashboard",
  riskRules: "Risk Rules",
  sandboxMode: "sandbox mode",
  searchCustomers: "Search customers",
  selected: "Selected {{count}} option",
  selected_plural: "Selected {{count}} options",
  "Sign out": "Sign out",
  "Sign Up": "Sign Up",
  "Something went wrong": "Something went wrong",
  somethingWentWrong: "Sorry, something went wrong. Please try again later.",
  sorryPageNotFound: "Sorry, the page was not found",
  status: "Status",
  thisTimestampInUTC:
    "This timestamp is in UTC. Your local time would be: {{fullDate}} {{hours}}",
  tooManyRequests: "Too many requests. Please, try again later.",
  Transactions: "Transactions",
  twoFaCodeHasBeenSentToYourVoltEmail:
    "2FA code has been sent to your Volt e-mail.",
  twoFaSecurityCode: "2FA security code",
  "User management": "User management",
  updatedBy: "Updated by",
  Users: "Users",
  value: "Value",
  viewing: "Viewing",
  "Volt Merchant": "Volt Merchant",
  youDoNotHavePermissions: "You don't have permission to access.",
  yourOneTimePasswordHasExpired:
    "Your one time password has expired. Please resend 2FA.",
};
